module.exports = __webpack_public_path__ + "img/homebg.06550d8c.jpg";